import React from 'react';
import { useTranslation } from 'react-i18next';
import { CustomModal, TextField, Button } from 'components/v3';
import { layouts } from 'config/constants';
import styles from './BranchCreateModal.scss';

const BranchCreateModal = ({
  open,
  onClose,
  newBranchName,
  setNewBranchName,
  validationError,
  setValidationError,
  isCreating,
  onCreateBranch
}) => {
  const { t } = useTranslation();

  const handleKeyDown = e => {
    if (e.key === 'Enter' && !isCreating) {
      const result = onCreateBranch();
      if (result && typeof result.catch === 'function') {
        result.catch(console.error);
      }
    }
  };

  if (!open) return null;

  return (
    <CustomModal
      layout={layouts.veezoo}
      open={open}
      onClose={onClose}
      title={t('branch.create-new-branch')}
      maxWidth="sm"
      hideButtons
      content={
        <div className={isCreating ? styles.loadingContainer : ''}>
          <div className={styles.descriptionContainer}>
            <p className={styles.modalDescription}>{t('branch.create-branch-description')}</p>
          </div>
          <div className={styles.inputContainer}>
            <TextField
              layout={layouts.veezoo}
              autoFocus
              label={t('branch.branch-name')}
              value={newBranchName || ''}
              onChange={e => {
                setNewBranchName(e.target.value);
                if (validationError) setValidationError(''); // Clear error on change
              }}
              onKeyDown={handleKeyDown}
              placeholder={t('branch.enter-branch-name')}
              disabled={isCreating}
              error={!!validationError}
              helperText={validationError || t('branch.character-count', { count: (newBranchName || '').length })}
              inputProps={{ maxLength: 28 }}
            />
          </div>
          <div className={styles.buttonContainer}>
            <Button
              layout={layouts.veezoo}
              mode="dark"
              fullWidth
              onClick={onCreateBranch}
              loading={isCreating}
              disabled={isCreating}
            >
              {isCreating ? t('branch.creating') : t('branch.create-branch')}
            </Button>
          </div>
        </div>
      }
    />
  );
};

export default BranchCreateModal;
